import { render, staticRenderFns } from "./BoolField.vue?vue&type=template&id=234c2ebb&scoped=true"
import script from "./BoolField.vue?vue&type=script&lang=js"
export * from "./BoolField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c2ebb",
  null
  
)

export default component.exports